import * as React from "react";
import { Target } from "lucide-react";
import { UniversalSelector } from "@/components/ui/universal-selector";

interface CostCenter {
  id: string;
  name: string;
}

interface CostCenterSelectorProps {
  costCenters: CostCenter[];
  value: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
  allowFreeText?: boolean;
  freeTextValue?: string;
  onFreeTextChange?: (value: string) => void;
  label?: string;
  error?: string;
  inputRef?: React.RefObject<HTMLInputElement>;
  onEnterPress?: () => void;
  required?: boolean;
  canAddNew?: boolean;
  onAddNew?: (name: string) => Promise<void>;
}

export function CostCenterSelector({
  costCenters,
  value,
  onValueChange,
  placeholder = "Selecione um centro de custos",
  allowFreeText = false,
  freeTextValue = "",
  onFreeTextChange,
  label = "Centro de Custos",
  error,
  inputRef,
  onEnterPress,
  required = true,
  canAddNew = false,
  onAddNew
}: CostCenterSelectorProps) {
  
  return (
    <UniversalSelector
      items={costCenters}
      value={value}
      onValueChange={onValueChange}
      placeholder={placeholder}
      allowFreeText={allowFreeText}
      freeTextValue={freeTextValue}
      onFreeTextChange={onFreeTextChange}
      label={label}
      error={error}
      inputRef={inputRef}
      onEnterPress={onEnterPress}
      icon={Target}
      required={required}
      canAddNew={canAddNew}
      onAddNew={onAddNew}
      addNewLabel="Adicionar Novo Centro de Custos"
    />
  );
}